export default __webpack_public_path__ + "static/AL_Montgomery_Experience-Montgomery_Riverfront-Park1920px-88cd56cf145f6349af2c0e4b089f4c2c.jpg";